import React, { useEffect } from 'react';
import { TourCard } from '../components/TourCard';
import { honeymoonPackages } from '../mockData';
import { Heart } from 'lucide-react';

export const HoneymoonPackages = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="honeymoon-packages-page">
      {/* Hero Section */}
      <section className="relative h-[300px] flex items-center justify-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1648538923547-074724ca7a18)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-sky-900/80 to-emerald-900/80"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <Heart className="w-16 h-16 mx-auto mb-4 text-pink-300" />
          <h1 className="text-5xl font-bold mb-4">Honeymoon Packages</h1>
          <p className="text-xl">Create unforgettable memories on your romantic getaway</p>
        </div>
      </section>

      {/* Tours Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Your Perfect Romantic Escape</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Celebrate your love with our specially curated honeymoon packages. From pristine beaches to 
              mountain retreats, from luxury resorts to intimate hideaways – we create the perfect beginning 
              to your journey together.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {honeymoonPackages.map((tour) => (
              <TourCard key={tour.id} tour={tour} />
            ))}
          </div>
          
          <div className="mt-12 bg-gradient-to-r from-pink-50 to-purple-50 p-8 rounded-lg max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Special Honeymoon Services</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
              <div className="flex items-start space-x-2">
                <Heart className="w-5 h-5 text-pink-500 flex-shrink-0 mt-1" />
                <span>Romantic candlelight dinners</span>
              </div>
              <div className="flex items-start space-x-2">
                <Heart className="w-5 h-5 text-pink-500 flex-shrink-0 mt-1" />
                <span>Couple spa treatments</span>
              </div>
              <div className="flex items-start space-x-2">
                <Heart className="w-5 h-5 text-pink-500 flex-shrink-0 mt-1" />
                <span>Sunset cruises & private tours</span>
              </div>
              <div className="flex items-start space-x-2">
                <Heart className="w-5 h-5 text-pink-500 flex-shrink-0 mt-1" />
                <span>Luxury accommodations</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};